module.exports = __webpack_public_path__ + "static/media/SKILL.5430493f.svg";